export const LOGOUT_URL_PATH = '/accounts/logout/';
export const REFRESH_TOKEN_AT = 60 * 60 * 24; // refresh JWT token if expires within 24 hours
export const COMPLETE = 'COMPLETE';
export const REJECTED = 'REJECTED';
export const COMPLETE_WITH_ERROR = 'COMPLETE_WITH_ERROR';
export const PENDING_APPROVAL = 'PENDING_APPROVAL';
export const INSPECTED = 'INSPECTED';
export const CONTESTED = 'CONTESTED';
export const ASSIGNED = 'ASSIGNED';
export const UNASSIGNED = 'UNASSIGNED';
export const FIELD_REQUIRED = 'This field is required!';
export const ROLE_OIS_ADMIN = 1;
export const ROLE_OIS_STAFF = 2;
export const ROLE_MEDIA_AGENCY = 3;
export const ROLE_MEDIA_OWNER = 4;
export const ROLE_UNASSIGNED = 5;
export const ROLE_CREATIVE_AGENCY = 6;

export const COUNTRIES = [
  { id: 'AU', name: 'Australia', phoneCode: '+61' },
  { id: 'CA', name: 'Canada', phoneCode: '+1' },
  { id: 'CN', name: 'China', phoneCode: '+86' },
  { id: 'HK', name: 'Hong Kong', phoneCode: '+852' },
  { id: 'IN', name: 'India', phoneCode: '+91' },
  { id: 'ID', name: 'Indonesia', phoneCode: '+62' },
  { id: 'JP', name: 'Japan', phoneCode: '+81' },
  { id: 'MY', name: 'Malaysia', phoneCode: '+60' },
  { id: 'NZ', name: 'New Zealand', phoneCode: '+64' },
  { id: 'PK', name: 'Pakistan', phoneCode: '+92' },
  { id: 'PH', name: 'Philippines', phoneCode: '+63' },
  { id: 'KR', name: 'Republic of Korea', phoneCode: '+82' },
  { id: 'SG', name: 'Singapore', phoneCode: '+65' },
  { id: 'LK', name: 'Sri Lanka', phoneCode: '+94' },
  { id: 'TH', name: 'Thailand', phoneCode: '+66' },
  { id: 'GB', name: 'United Kingdom', phoneCode: '+44' },
  { id: 'US', name: 'United States of America', phoneCode: '+1' },
  { id: 'VN', name: 'Viet Nam', phoneCode: '+84' }
];

export const CAMPAIGN_TYPES = [
  { id: 'CAMPAIGN', name: 'Campaign' },
  { id: 'SQABASELINE', name: 'SQA Baseline' },
  { id: 'NETWORKTEST', name: 'Network Test' }
];

export const REPORT_TYPES = [
  { id: 'ALL', value: 'ALL', name: 'All' },
  { id: 'POP', value: 'POP', name: 'Proof of play' },
  { id: 'BASELINE', value: 'BASELINE', name: 'Baseline' },
  { id: 'INSTALL', value: 'INSTALL', name: 'Installation' }
];

export const ROLES = [
  { id: ROLE_OIS_ADMIN, name: 'OIS Admin' },
  { id: ROLE_OIS_STAFF, name: 'OIS Staff' },
  { id: ROLE_MEDIA_AGENCY, name: 'Agency' },
  { id: ROLE_CREATIVE_AGENCY, name: 'Creative Agency' },
  { id: ROLE_MEDIA_OWNER, name: 'Publisher' },
  { id: ROLE_UNASSIGNED, name: 'Unassigned' }
];

export const ROLE_TIERS = [
  { id: 0, name: 'Restricted' },
  { id: 1, name: 'Standard' },
  { id: 2, name: 'Professional' }
];

export const DAYS_OPTIONS = [
  {
    value: 'A_1',
    label: 'Monday',
    inputValue: 1
  },
  {
    value: 'A_2',
    label: 'Tuesday',
    inputValue: 2
  },
  {
    value: 'A_3',
    label: 'Wednesday',
    inputValue: 3
  },
  {
    value: 'A_4',
    label: 'Thursday',
    inputValue: 4
  },
  {
    value: 'A_5',
    label: 'Friday',
    inputValue: 5
  },
  {
    value: 'A_6',
    label: 'Saturday',
    inputValue: 6
  },
  {
    value: 'A_7',
    label: 'Sunday',
    inputValue: 7
  }
]

export const CONDITION_DETAIL_DAMAGED = 'DAMAGED';
export const CONDITION_DETAIL_NAME_DAMAGED = 'Damaged';
export const ISSUE_OPTIONS_DAMAGED = [
  {
    value: 'damaged-broken-dead-pixel',
    name: 'Broken/dead Pixel'
  },
  {
    value: 'damaged-broken-glass',
    name: 'Broken Glass'
  },
  {
    value: 'damaged-graffitti',
    name: 'Graffitti'
  },
  {
    value: 'damaged-blank-screen',
    name: 'Blank Screen'
  },
  {
    value: 'damaged-upside-down',
    name: 'Upside down'
  },
  {
    value: 'damaged-offscreen',
    name: 'Offscreen'
  },
  {
    value: 'damaged-screen-error',
    name: 'Screen Error'
  },
  {
    value: 'damaged-broken-scroller',
    name: 'Broken Scroller'
  },
  {
    value: 'damaged-water-damage',
    name: 'Water Damage'
  },
  {
    value: 'damaged',
    name: 'Damaged'
  },
  {
    value: 'graffiti',
    name: 'Graffiti'
  },
  {
    value: 'obstructed',
    name: 'Obstructed'
  },
  {
    value: 'screen-error',
    name: 'Screen Error'
  },
  {
    value: 'other',
    name: 'Other'
  },
  {
    value: 'damaged-installed',
    name: 'Damaged (Installed)'
  },
];

export const CONDITION_DETAIL_OBSTRUCTION = 'OBSTRUCTION';
export const CONDITION_DETAIL_NAME_OBSTRUCTION = 'Obstruction';
export const ISSUE_OPTIONS_OBSTRUCTION = [
  {
    value: 'obstruction-a-tree',
    name: 'A Tree'
  },
  {
    value: 'obstruction-a-fence',
    name: 'A Fence'
  },
  {
    value: 'obstruction-building-works',
    name: 'Building Works'
  },
  {
    value: 'obstruction-other',
    name: 'Other'
  }
];

export const CONDITION_DETAIL_NOT_POSTED = 'NOT_POSTED';
export const CONDITION_DETAIL_NAME_NOT_POSTED = 'Not posted';
export const ISSUE_OPTIONS_NOT_POSTED = [
  {
    value: 'not-posted-not-in-loop',
    name: 'Not in loop'
  },
  {
    value: 'not-posted-wrong-advertiser',
    name: 'Wrong advertiser'
  },
  {
    value: 'not-posted-poster-not-showing',
    name: 'Poster not showing'
  },
  {
    value: 'blank-screen',
    name: 'Blank Screen'
  },
  {
    value: 'not-posted',
    name: 'Advert not posted'
  },
  {
    value: 'incorrect-creative',
    name: 'Incorrect creatives'
  },
  {
    value: 'incorrect-creative-installed',
    name: 'Different creative supplied (Installed)'
  }
];

export const CONDITION_DETAIL_NO_PANEL = 'NO_PANEL';
export const CONDITION_DETAIL_NAME_NO_PANEL = 'No panel';
export const ISSUE_OPTIONS_NO_PANEL = [
  {
    value: 'no-panel-missing',
    name: 'Panel missing'
  },
  {
    value: 'no-panel-locked-building',
    name: 'Locked building'
  },
  {
    value: 'no-panel-closed-indefinitely',
    name: 'Closed indefinitely'
  },
  {
    value: 'no-panel-refused-access',
    name: 'Refused access'
  },
  {
    value: 'no-panel-closed-temporarily',
    name: 'Closed temporarily'
  },
  {
    value: 'no-panel',
    name: 'Other - No panel at location'
  },
  {
    value: 'no-access',
    name: 'No access to location'
  }
];

export const CONDITION_DETAIL_NOT_ILLUMINATED = 'NOT_ILLUMINATED';
export const CONDITION_DETAIL_NAME_NOT_ILLUMINATED = 'Not illuminated';
export const ISSUE_OPTIONS_NOT_ILLUMINATED = [
  {
    value: 'not-illuminated',
    name: 'Not Illuminated'
  }
];

export const CONDITION_DETAIL_INVALID_SOV = 'INVALID_SHARE_OF_VOICE';
export const CONDITION_DETAIL_NAME_INVALID_SOV = 'Invalid share of voice';
export const ISSUE_OPTIONS_INVALID_SHARE_OF_VOICE = [
  {
    value: 'invalid-share-of-voice-value-reported',
    name: 'Invalid share of voice value reported.'
  },
  {
    value: 'invalid-share-of-voice-reported',
    name: 'Invalid share of voice reported.'
  }
];

export const CONDITION_DETAIL_INVALID_PROXIMITY = 'INVALID_PROXIMITY';
export const CONDITION_DETAIL_NAME_INVALID_PROXIMITY = 'Invalid proximity';

export const CONDITION_DETAIL_INVALID_LOCATION = 'INVALID_LOCATON';
export const CONDITION_DETAIL_NAME_INVALID_LOCATION = 'Location';
export const ISSUE_OPTIONS_INVALID_LOCATION = [
  {
    value: 'incorrect-geo',
    name: 'Incorrect Geo'
  }
];

export const CONDITION_DETAIL_COMPETITOR = 'COMPETITOR';
export const CONDITION_DETAIL_NAME_COMPETITOR = 'Competitor';
export const ISSUE_OPTIONS_COMPETITOR_IN_LOOP = [
  {
    value: 'competitor-in-loop',
    name: 'Competitor in Loop'
  }
];

export const ISSUE_OPTIONS = [
  {
    value: CONDITION_DETAIL_DAMAGED,
    name: CONDITION_DETAIL_NAME_DAMAGED,
    type: 'group',
    items: [ ...ISSUE_OPTIONS_DAMAGED ]
  },
  {
    value: CONDITION_DETAIL_OBSTRUCTION,
    name: CONDITION_DETAIL_NAME_OBSTRUCTION,
    type: 'group',
    items: [ ...ISSUE_OPTIONS_OBSTRUCTION ]
  },
  {
    value: CONDITION_DETAIL_NOT_POSTED,
    name: CONDITION_DETAIL_NAME_NOT_POSTED,
    type: 'group',
    items: [ ...ISSUE_OPTIONS_NOT_POSTED ]
  },
  {
    value: CONDITION_DETAIL_NO_PANEL,
    name: CONDITION_DETAIL_NAME_NO_PANEL,
    type: 'group',
    items: [ ...ISSUE_OPTIONS_NO_PANEL ]
  },
  {
    value: CONDITION_DETAIL_NOT_ILLUMINATED,
    name: CONDITION_DETAIL_NAME_NOT_ILLUMINATED,
    type: 'group',
    items: [ ...ISSUE_OPTIONS_NOT_ILLUMINATED ]
  },
  {
    value: CONDITION_DETAIL_INVALID_SOV,
    name: CONDITION_DETAIL_NAME_INVALID_SOV,
    type: 'group',
    items: [ ...ISSUE_OPTIONS_INVALID_SHARE_OF_VOICE ]
  },
  {
    value: CONDITION_DETAIL_INVALID_LOCATION,
    name: CONDITION_DETAIL_NAME_INVALID_LOCATION,
    type: 'group',
    items: [ ...ISSUE_OPTIONS_INVALID_LOCATION ]
  },
  {
    value: CONDITION_DETAIL_COMPETITOR,
    name: CONDITION_DETAIL_NAME_COMPETITOR,
    type: 'group',
    items: [ ...ISSUE_OPTIONS_COMPETITOR_IN_LOOP ]
  },
  {
    value: 'INCORRECT_CREATIVE',
    name: 'Incorrect Creative',
    type: 'group',
    items: [{
      value: 'posted-incorrect-creative',
      name: 'Incorrect Creative'
    }]
  },
  {
    value: 'NON_COMPLIANT',
    name: 'Non-Compliant',
    type: 'group',
    items: [{
      value: 'non-compliant-creative',
      name: 'Non-Compliant'
    }]
  }
];

export const ALL_ISSUES = [
  ...ISSUE_OPTIONS_DAMAGED,
  ...ISSUE_OPTIONS_OBSTRUCTION,
  ...ISSUE_OPTIONS_NOT_POSTED,
  ...ISSUE_OPTIONS_NO_PANEL,
  ...ISSUE_OPTIONS_NOT_ILLUMINATED,
  ...ISSUE_OPTIONS_INVALID_SHARE_OF_VOICE,
  ...ISSUE_OPTIONS_INVALID_LOCATION,
  ...ISSUE_OPTIONS_COMPETITOR_IN_LOOP
];

export const CAMPAIGN_CREATIVE_STATUS = {
  0: '',
  1: 'success',
  2: 'warning',
  3: 'error'
};

export const ISSUES_VUEBI = [
  {
    category: 'NO_PANEL',
    value: 'no-panel',
    label: 'No panel at location'
  },
  {
    category: 'NO_PANEL',
    value: 'no-access',
    label: 'No access to location'
  },
  {
    category: 'NOT_POSTED',
    value: 'blank-screen',
    label: 'Blank Screen'
  },
  {
    category: 'NOT_POSTED',
    value: 'not-posted',
    label: 'Advert not posted'
  },
  {
    category: 'NOT_POSTED',
    value: 'incorrect-creative',
    label: 'Incorrect creatives'
  },
  {
    category: 'DAMAGED',
    value: 'damaged',
    label: 'Damaged'
  },
  {
    category: 'DAMAGED',
    value: 'graffiti',
    label: 'Graffiti'
  },
  {
    category: 'DAMAGED',
    value: 'obstructed',
    label: 'Obstructed'
  },
  {
    category: 'DAMAGED',
    value: 'screen-error',
    label: 'Screen Error'
  },
  {
    category: 'DAMAGED',
    value: 'other',
    label: 'Other'
  },
  {
    category: 'DAMAGED',
    value: 'damaged-installed',
    label: 'Damaged (Installed)'
  },
  {
    category: 'NOT_POSTED',
    value: 'incorrect-creative-installed',
    label: 'Different creative supplied (Installed)'
  }
];